<template>

    <div class="feedItem panel">
        <div class="w-100 mb-2 font-weight-600"><span class="ml-1">News</span></div>
        <div class="d-flex mb-2 darker newsRowHolder" v-for="newsItem, index in newsArr" v-if="index < numberOfNewsToShow">
            <a class="colorInherit w-100 d-flex" :href="newsItem.link" target="_blank">
                <div class="iamgeHolder" v-if="newsItem.image" :style="'background-image: url('+newsItem.image+')'">
                </div>

                <div class="textHolder px-2 d-flex flex-column justify-content-between" :class="{'w-100': !newsItem.image}">
                    <div class="font-weight-600 fs-large">{{newsItem.title}}</div>
                    <div class="fs-small medium">{{formatDate(newsItem.date) +' '+formatTime(newsItem.date)}}</div>
                </div>
            </a>

        </div>
    </div>

</template>

<script>

export default {
    created: function(){
        this.getNews();
    },
    data: function() {
        return{
            newsArr: [],
            numberOfNewsToShow: 2,
            image:'',
            title:'Qatar: Portugal entre os países isentos de Visa.',
            subTitle:'Medida visa atrair mais turistas ao país e tem efeito imediato.',
            date:'07 DE NOVEMBRO DE 2017, POR PUBLITURIS',
            link:'#',
            forcedNews: {
                image: 'http://i.imgur.com/aG5AXH1.png',
                title: 'Empresa algarvia Pluralo foi à Web Summit apresentar plataforma digital para turismo',
                date: '2018-11-08 11:43',
                link: 'https://www.sulinformacao.pt/2018/11/empresa-algarvia-pluralo-foi-a-web-summit-apresentar-plataforma-digital-para-turismo/',
            }
        }
    },
    methods:{
        getNews: function (){
            var vm = this;
            var invocation = new XMLHttpRequest();
            var rss2json = 'https://api.rss2json.com/v1/api.json?rss_url=';
            var targeturl = 'https%3A%2F%2Fnews.google.com%2Fnews%2Frss%2Fsearch%2Fsection%2Fq%2Fturism%2520portugal%2Fturism%2520portugal%3Fhl%3Den';
            var response = null;
            var outputArr = [];

            invocation.onreadystatechange = function() {
                if (this.readyState == 4 && this.status == 200){
                    response = JSON.parse(this.responseText);

                    for (let newsItem of response.items) {
                        let singleNewObj = {}
                        var stringToFindImage = newsItem.description.replace(/(\r\n|\n|\r)/gm,"").replace(/'/g, '"'); //remove line breaks | replaces single quotes with regular quotes
                        //console.log(stringToFindImage);

                        var elem= document.createElement("div");
                        elem.innerHTML = stringToFindImage;

                        var images = elem.getElementsByTagName("img");

                        //for(var i=0; i < images.length; i++){
                        //   console.log(images[i].src);
                        //}
                        if(images.length > 0){
                            singleNewObj.image = images[0].src;
                        }
                        singleNewObj.title = newsItem.title;
                        singleNewObj.date = newsItem.pubDate;
                        singleNewObj.link = newsItem.link;

                        outputArr.push(singleNewObj);
                    }

                    outputArr.sort(function(a, b){
                        if(a.image && b.image === undefined){
                            return -1;
                        } else if(b.image && a.image === undefined){
                            return 1;
                        } else {
                            return 0;
                        }
                    })

                    vm.newsArr = outputArr;
                    // vm.newsArr[0] = vm.forcedNews

                }
            };

            invocation.open('GET', rss2json+targeturl, true);
            invocation.send();
        }
    },
    props: {
        cardInfo: {
            type: Object
        }
    }
}
</script>

<style scoped lang="scss">
    @import '../../assets/scss/_variables.scss';

    .feedItem{
        position: relative;
        overflow: hidden;
        z-index: 1;
        height: auto !important;
    }

    .cardBg{
        position: absolute;
        background-position: center;
        background-size: cover;
        right: 0;
        top: 0;
        z-index: 0;
    }

    .cardContent{
        background-color: transparentize($black, 0.2);
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
    }

    .colorInherit{
        color: inherit;
    }

    .newsRowHolder{
        height: 100px;

        .iamgeHolder{
            width: 35%;
            height: 100%;
            background-size: cover;
            background-position: center;
        }

        .textHolder{
            width: 65%;
        }

    }

</style>



// WEBPACK FOOTER //
// FeedcardNews.vue?1f2a40a8